import { useQuery } from '@tanstack/react-query';
import { WebsiteService } from '@/services/WebsiteService';

export function useWebsitePages() {
  return useQuery({
    queryKey: ['website-pages'],
    queryFn: () => WebsiteService.fetchAllPages(),
    staleTime: 0,
  });
}
